import { Component, OnInit, Input } from '@angular/core';
import { IProvider } from '../providersearch_model/provider.model';
import { IProviderDetails } from '../providersearch_model/providerdetails';
import { IProviderContract } from '../providersearch_model/providerdetails';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { CupService } from '../../shared/services/cup.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SecureStorageService } from '../../secure-storage.service';

@Component({
    selector: 'app-providerdetails',
    templateUrl: './providerdetails.component.html',
    styleUrls: ['./providerdetails.component.css'],
    standalone: false
})
export class ProviderDetailsComponent implements OnInit {
  @Input() providerIdFromMember: number;
  @Input() specialtyUidFromMember: number;
  @Input() contractUidFromMember: number;
  @Input() fromMember: boolean;
  public providerDetailsColumns = [];
  public providerDetailsGridRow = [];
  public providerId: number;
  public pcpName: string;
  public selectedProviderAddress: string;
  public selectedProviderDestination: string;
  public providerDetailsData: IProviderDetails;
  public providerData: IProvider;
  public selectedProvider: any;
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  public paramterPassed = false;
  public pcpPassed = false;
  public traversalProviderData: any;
  public selectedProviderDetails: any;
  public isProviderMapRequest = false;
  public isAuthSummaryMapRequest = false;
  public pageFromParent: Number;
  public overAllSearchResultSubscription: any;
  public isOverallSearchResultSingle = false;
  public regions: string;
  public authId: number;
  public hideTabAlone = true;
  private authType: string;
  private source: string;

  constructor(private urlconstantsService: UrlconstantsService, private cupService: CupService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private secureStorage:SecureStorageService) {
    if (this.router.url.indexOf('/home/provider/provider-details/map') !== -1) {
      this.isProviderMapRequest = true;
    } else {
      this.isProviderMapRequest = false;
      this.selectedProvider = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('providerDetails'));
      // this.traversalProviderData = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('providerTraversal'));
      this.providerDetailsData = new IProviderDetails();
      this.initProviderDetailGridCol();
    }
  }

  public backToAuthSummary() {

    this.router.navigate(['home/general/auth-summary', this.authId, this.authType], { queryParamsHandling: 'preserve' });
    // if(this.source){
    //   let queryParamObj = { queryParams: { source: this.source } };
    //   this.router.navigate(['home/general/auth-summary', this.authId, this.authType],queryParamObj);
    // }else{
    //   this.router.navigate(['home/general/auth-summary', this.authId, this.authType]);
    // }
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.source = this.activatedRoute.snapshot.queryParams['source'];
      this.providerId = params['providerId'];
      this.pcpName = params['pcpName'];
      if (this.providerId && this.pcpName) {
        this.pcpPassed = true;
        this.paramterPassed = true;
      } else if (this.providerId) {
        this.paramterPassed = true;
      } else {
        this.paramterPassed = false;
      }
      this.selectedProviderAddress = params['address'];

      const sourceAddress = params['sourceaddress'];
      const destAddress = params['destaddress'];
      this.authId = params['authId'];
      this.authType = params['authType'];

      if (this.authId) {
        this.isProviderMapRequest = false;
        this.isAuthSummaryMapRequest = true;
      }

      if (destAddress) {

        this.selectedProviderAddress = sourceAddress;
        this.selectedProviderDestination = destAddress;
      }

      // alert(this.selectedProviderAddress);
      
    });
    if (!this.isProviderMapRequest && !this.isAuthSummaryMapRequest) {
      this.getProviderDetails();
    }

    this.isOverAllSearchResultSingle();
  }
  private initProviderDetailGridCol() {
    this.providerDetailsColumns = [
      { field: 'neighbourhood', header: 'NEIGHBORHOOD', style: { 'width': '75px' }, sortable: 'true' },
      { field: 'group', header: 'GROUP', style: { 'width': '40px' }, sortable: 'true' },
      { field: 'speciality', fieldType: 'specialtyData', header: 'SPECIALTY', style: { 'width': '100px' }, sortable: 'true' },
      { field: 'address', header: 'ADDRESS', style: { 'width': '100px' }, sortable: 'true' },
      { field: 'phone', header: 'PHONE', style: { 'width': '80px' }, sortable: 'true' },
      { field: 'status', header: 'STATUS', style: { 'width': '55px', }, sortable: 'true' },
    ];
  }

  private getIDs(type: string, idJson: any) {
    const ids = [];
    if (idJson) {
      idJson.forEach(function (obj) {
        if (obj.type === type) {
          ids.push(obj.value);
        }
      });
    } return ids.join(', ');
  }

  private getPrimarySpecialty(specialtyJson: any) {
    const specialty = [];
    if (specialtyJson) {
      specialtyJson.forEach(function (obj) {
        if (obj.primary === true) {
          specialty.push(obj.description);
        }
      });
    }
    return specialty.join(', ');
  }

  private getProviderDetails() {
    this.providerId = this.providerIdFromMember ? this.providerIdFromMember : this.providerId;
    const providerId = this.providerId ? this.providerId : this.selectedProvider.id;
    const specialtyUidFromMember = this.specialtyUidFromMember;
    const specialtyUid = (specialtyUidFromMember || specialtyUidFromMember == 0) ? specialtyUidFromMember : (this.selectedProvider && this.selectedProvider.specialityUid) ? this.selectedProvider.specialityUid : 0;
    const selectedProviderContractUid = this.fromMember ? (this.contractUidFromMember || this.contractUidFromMember == 0) ? this.contractUidFromMember : 0 : (this.selectedProvider && this.selectedProvider.providerContractUid) ? this.selectedProvider.providerContractUid : 0;

    const url = this.urlConstant.providerGridDetails + providerId + '?providerspecialtyuid=' + specialtyUid + '&providercontractuid=' + selectedProviderContractUid;


    this.cupService.isShowSpinner(true);
    this.cupService.retrieveData('get', url).subscribe(data => {
      if (data != null) {
        this.providerData = data;
        this.providerDetailsData.name = this.providerData.name;

        let userSites = '';
        if (this.providerData.authTypeRole && this.providerData.authTypeRole.length > 0) {
          this.providerData.authTypeRole.forEach((x, i) => {
            if (i == 0) {
              userSites = x.site;
            } else {
              userSites = userSites + ',' + x.site;
            }
          });
        }

        this.providerDetailsData.userSite = userSites;
        this.providerDetailsData.taxId = this.getIDs('TAXID', this.providerData.alternateid);
        this.providerDetailsData.npiId = this.getIDs('NPI', this.providerData.alternateid);

        const searchableTypes = [];
        if (this.providerData.authTypeRole && this.providerData.authTypeRole.length > 0) {

          this.providerData.authTypeRole.forEach(x => {
            if (x.roles && x.roles.length > 0) {
              searchableTypes.push(x.roles.join(','));
            }
          });
        }
        if (searchableTypes && searchableTypes.length > 0) {
          this.providerDetailsData.searchableTypes = searchableTypes.join(',');
        } else {
          this.providerDetailsData.searchableTypes = '';
        }
        this.providerDetailsData.internalId = this.providerData.providerId;
        const speciality = this.getPrimarySpecialty(this.providerData.speciality);
        this.providerDetailsData.office = speciality;

        if (this.providerData.contract && this.providerData.contract.length > 0) {
          // this.cupService.updateTotalCount(true);
          let regionsList = '';
          const providerContracts: IProviderContract[] = [];
          this.providerData.contract.forEach(function (obj) {
            const c = new IProviderContract();
            c.neighbourhood = obj.neighborhood;
            c.group = obj.group;
            c.region = obj.region;
            c.speciality = obj.specialty;

            let address = '';
            if (obj.address) {
              const addressObj = obj.address;
              if (addressObj.address1) {
                address = addressObj.address1;
              }
              if (addressObj.address2 && addressObj.address2.trim()) {
                address = address ? address + ', ' + addressObj.address2 : address;
              }
              if (addressObj.city) {
                address = address ? address + ', ' + addressObj.city : address;
              }
              if (addressObj.state) {
                address = address ? address + ', ' + addressObj.state : address;
              }
              if (addressObj.zipCode) {
                address = address ? address + ', ' + addressObj.zipCode : address;
              }
            }
            c.address = address;
            c.phone = (obj.address.phone ? ' Phone-' + obj.address.phone : '') + (obj.address.fax && obj.address.phone ? '\nFax-' + obj.address.fax : obj.address.fax ? 'Fax-' + obj.address.fax : '');
            c.status = obj.parStatus;
            providerContracts.push(c);

            if (regionsList == '') {
              regionsList = obj.region;
            } else {
              regionsList = regionsList + ',' + obj.region;
            }
          });

          this.regions = regionsList;
          this.providerDetailsGridRow = providerContracts;
          this.pageFromParent = Math.ceil(this.providerData.contract.length / 5);
        } else {
          this.providerDetailsGridRow = [];
        }
      }
      this.cupService.isShowSpinner(false);
    }, error => {
      this.cupService.isShowSpinner(false);
    });
  }

  /*Traversal*/
  public traverseTowards(event) {
    let currentRecordNumber, beginRecordNumber, endRecordNumber, length;
    currentRecordNumber = event.rowNum;
    length = this.traversalProviderData.length;
    beginRecordNumber = this.traversalProviderData[0].rowNum;
    endRecordNumber = this.traversalProviderData[length - 1].rowNum;
    if (event.traverseTo === 'next') {
      currentRecordNumber = currentRecordNumber + 1;
    } else if (event.traverseTo === 'previous') {
      currentRecordNumber = currentRecordNumber - 1;
    } else if (event.traverseTo === 'first') {
      currentRecordNumber = beginRecordNumber;
    } else if (event.traverseTo === 'last') {
      currentRecordNumber = endRecordNumber;
    }
    let currentRecord;
    for (let i = 0; i <= this.traversalProviderData.length - 1; i++) {
      if (this.traversalProviderData[i].rowNum === currentRecordNumber) {
        currentRecord = this.traversalProviderData[i];
      }
    }
    this.cupService.updateTraversalDetails(currentRecordNumber, endRecordNumber);
    this.providerId = currentRecord.id;
    this.getProviderDetails();
    // this.getMemberDetails(anotherMemberObj);
  }

  /*To Check if Over All Search Result is Single */
  public isOverAllSearchResultSingle() {
    this.overAllSearchResultSubscription = this.cupService.overAllSearchResultSingle.subscribe(data => {
      this.isOverallSearchResultSingle = data;
    });
  }
}
